import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxCalendarConfiguration from '../services/getMailboxCalendarConfiguration';
export default action('initCalendarMailboxConfiguration')(function initCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (store.calendarConfiguration) {
                        // If we already have the mailbox configuration, we won't get it again
                        return [2 /*return*/];
                    }
                    _a = store;
                    return [4 /*yield*/, getMailboxCalendarConfiguration()];
                case 1:
                    _a.calendarConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initCalendarMailboxConfiguration.js.map